import React, {useEffect, useState} from 'react';
import styles from './SitePreviewCard.module.css';
import debounce from 'lodash.debounce';
import opengraphAPI from '../../../shared/apis/opengraph-api-web';
import {Card, CardMedia, CardContent, IconButton} from '@material-ui/core';
import {
  getDomain,
  validURL,
  setOpenGraphData,
  cleanLinkID,
  openGraphFallbackPreview,
} from '../../../shared/utils/Helpers';

import {projectConfig} from '../../../shared/project-info/projectConfig';
import {handleLinkClick} from '../../../shared/utils/HandleLinkClick.react';
import XIcon from './svgs/XIcon';
import LinksIcon from './svgs/LinksIcon';

const DEBOUNCE_MS = 1000;
const SitePreviewCard = (props) => {
  const [data, setData] = useState(null);
  const {onClose, cancelable, storePreviewData, graphData} = props;
  let {link} = props;
  const [isLoading, setIsLoading] = useState(false);
  // openGraph always adds a trailing / after url
  // open graph sometimes removes analytic data (trailing ?), making analytic links never match their format
  const newLink =
    cleanLinkID(graphData?.url) !== cleanLinkID(link.toLowerCase()) &&
    graphData?.url?.slice(0, -1) !== link.toLowerCase();
  useEffect(() => {
    if (!projectConfig.hasOpenGraphPreviews) {
      return;
    } else if ((!graphData || newLink) && validURL(link)) {
      setIsLoading(true);
      const debouncedOpenGraph = debounce(() => {
        opengraphAPI
          .get(link)
          .then((data) => {
            // if the site was unreachable for any reason the placeholder open graph data will be used which is missing the timestamp and all other information
            const validOpenGraphData =
              data.timestamp &&
              (!data?.openGraph?.error ||
                !data?.hybridGraph?.error ||
                !data?.htmlInferred?.error);
            if (validOpenGraphData) {
              const openGraphData = setOpenGraphData(
                data?.openGraph,
                data?.hybridGraph,
                data?.htmlInferred,
                data?.url,
              );
              setData(openGraphData);
              if (storePreviewData) storePreviewData(openGraphData);
            } else {
              // the data returned is the placeholder data, store that instead of formatting the data from opengraph
              setData(data);
              if (storePreviewData) storePreviewData(data);
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            console.warn('Error fetching site data', err);
          });
      }, DEBOUNCE_MS);
      debouncedOpenGraph();
      return () => debouncedOpenGraph.cancel();
    } else {
      setData(graphData);
      setIsLoading(false);
    }
  }, [link]);

  const openLink = (evt, url) => {
    evt.stopPropagation();
    evt.preventDefault();
    handleLinkClick(url);
  };

  return (
    <>
      {isLoading ? (
        <div>
          <h6>loading preview...</h6>
        </div>
      ) : data ? (
        <Card
          className={styles.cardContainer}
          onClick={(e) => openLink(e, link)}>
          {/* image_url used for backend stored image url */}
          {data?.image || data?.image_url ? (
            <CardMedia
              component="img"
              className={styles.cardCover}
              src={data.image || data.image_url}
              alt="Page preview"
            />
          ) : (
            <LinksIcon className={styles.fallbackIcon} />
          )}
          <CardContent className={styles.cardContent}>
            <div>
              <div className={styles.siteTitle}>{data.title}</div>
              {data.description && (
                <p className={styles.siteDescription}>{data.description}</p>
              )}
            </div>
            <div className={styles.siteLink}>{getDomain(data.url)}</div>
          </CardContent>
          {cancelable ? (
            <div>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onClose();
                }}
                className={styles.cancelButton}
                color="inherit">
                <XIcon tintColor="var(--magenta)" />
              </IconButton>
            </div>
          ) : null}
        </Card>
      ) : null}
    </>
  );
};

export default SitePreviewCard;
